module.exports = __webpack_public_path__ + "static/media/wizualizacja-144.00d28d14.png";